import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateDocumentInstanceMutation,
  UpdateDocumentInstanceMutationVariables,
} from '@/gql/graphql';

const UpdateDocumentInstance = graphql(`
  mutation UpdateDocumentInstance($input: UpdateDocumentInstanceInput!) {
    updateDocumentInstance(input: $input) {
      id
      name
    }
  }
`);

const useUpdateDocumentInstance = (
  options?: UseMutationOptions<
    UpdateDocumentInstanceMutation,
    unknown,
    UpdateDocumentInstanceMutationVariables['input']
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UpdateDocumentInstance, {
        input,
      });
    },
    ...options,
  });
};

export default useUpdateDocumentInstance;
